import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./reducers/authReducer"; // Import the auth reducer
import alertReducer from "./reducers/alertReducer";
import Branches from "./reducers/branchReducer";
import Workspace from "./reducers/workspaceReducer";
import Cities from "./reducers/cityReducer";
import Amenities from "./reducers/amenityReducer";
import Users from "./reducers/userReducer";
import Roles from "./reducers/rolesReducer";
import Coupons from "./reducers/couponReducer";
import GlobalSettings from "./reducers/globalSettingReducer";
import Closures from "./reducers/closureReducer";
import Notifications from "./reducers/notificationReducer";
import Orders from "./reducers/orderReducer";
import Customers from "./reducers/customerReducer";
import Dashboards from "./reducers/dashboardReducer";
import Subscriptions from "./reducers/subscriptionReducer";
import Offers from "./reducers/offerReducer";


const store = configureStore({
  reducer: {
    auth: authReducer,
    Alert: alertReducer,
    Branches,
    Cities,
    Workspace,
    Amenities,
    Users,
    Roles,
    Coupons,
    GlobalSettings,
    Closures,
    Notifications,
    Orders,
    Customers,
    Dashboards,
    Subscriptions,
    Offers

  },
});

export default store;
